module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-container"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "loginForm",
    staticClass: "card-box login-form",
    attrs: {
      "autoComplete": "on",
      "model": _vm.loginForm,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('el-form-item', [_c('span', {
    staticClass: "svg-container"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "m-t-10",
    attrs: {
      "name": "userName",
      "type": "text",
      "placeholder": "请输入用户名"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.userName),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "userName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.userName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "svg-container"
  }, [_c('i', {
    staticClass: "fa fa-lock",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('el-input', {
    staticClass: "m-t-10",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "请输入密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    staticClass: "cus-button",
    attrs: {
      "type": "primary",
      "size": "medium",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLogin.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        登录\n    ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "login-tip"
  }, [_vm._v("没有账号？去"), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.goRegister(1)
      }
    }
  }, [_vm._v("注册")])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.goRegister(2)
      }
    }
  }, [_vm._v("找回密码")])], 1)])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-top",
    attrs: {
      "id": "canvas"
    }
  }, [_c('div', {
    attrs: {
      "id": "anitOut"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "title"
  }, [_vm._v("上海商晟通云网络科技有限公司")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-c6f540b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 1085
// module chunks = 3